import AllTPaidCourses from './AllTPaidCourses';
import './TPaidCourses.css';

const TPaidCourses = () =>{
    return(
        <div id="TPaidCourses">
            <div id="TPaidCoursesText">Trending Paid Courses</div>
            <AllTPaidCourses />
        </div>
    )
}

export default TPaidCourses;